import TextInputButton from './TextInputButton';

export default TextInputButton;
